import React from 'react';
import { Switch, withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import App from './App';
import SignUp from './scenes/SignUp';
import SignIn from './scenes/SignIn';
import Sessions from './scenes/Sessions';
import Courts from './scenes/Courts';
import Subscription from './scenes/Subscription';
import SingleSession from './scenes/SingleSession';
import ErrorPage from './scenes/ErrorPage';
import MyBookings from './scenes/MyBookings';
import ProtectedRoute from './utils/ProtectedRoute';
import AnalyticsRoute from './utils/AnalyticsRoute';
import routeConstants from './utils/routeConstants';
import ConditionHelperObj from './utils/helpers/ConditionHelper';
import AttendeesList from './scenes/AttendeesList';
import CourtsFilters from './scenes/CourtsFilters';
import DeucePremium from './scenes/DeucePremium';
import Account from './scenes/Account';
import UpdateCard from './scenes/UpdateCard';
import ForgotPassword from './scenes/ForgotPassword';
import ResetPassword from './scenes/ResetPassword';
import ErrorBoundary from './ErrorBoundary';

class AppRoutes extends React.Component {
  render() {
    return (
      <ErrorBoundary>
        <App>
          <Switch>
            <ProtectedRoute
              exact
              path={ routeConstants.HOME_ROUTE }
              condition={ () => false }
              elseRoute={ this.props.defaultHomeRoute }
            />
            <AnalyticsRoute
              exact
              path={ routeConstants.ATTENDEES_LIST_ROUTE(':accessToken') }
              component={ AttendeesList }
            />
            <AnalyticsRoute
              path={ routeConstants.SIGNUP_ROUTE }
              component={ SignUp }
            />
            <AnalyticsRoute
              path={ routeConstants.SIGNIN_ROUTE }
              component={ SignIn }
            />
            <AnalyticsRoute
              exact
              path={ routeConstants.SESSIONS_ROUTE }
              component={ Sessions }
            />
            <AnalyticsRoute
              exact
              path={ routeConstants.COURTS_ROUTE }
              component={ Courts }
            />
            <AnalyticsRoute
              exact
              path={ routeConstants.SINGLE_SESSION_ROUTE(':id') }
              component={ SingleSession }
            />
            <AnalyticsRoute
              exact
              path={ routeConstants.COURTS_FILTERS_ROUTE }
              component={ CourtsFilters }
            />
            <ProtectedRoute
              path={ routeConstants.MY_BOOKINGS_ROUTE }
              component={ MyBookings }
              condition={ () => ConditionHelperObj.isUserLogged() }
              elseRoute={ routeConstants.SIGNUP_ROUTE }
            />
            <ProtectedRoute
              path={ routeConstants.ACCOUNT_ROUTE }
              component={ Account }
              condition={ () => ConditionHelperObj.isUserLogged() && this.props.showAccount }
              elseRoute={ routeConstants.SIGNUP_ROUTE }
            />
            <ProtectedRoute
              path={ routeConstants.SUBSCRIPTION_PAGE }
              component={ Subscription }
              condition={ () => ConditionHelperObj.isUserLogged() }
              elseRoute={ routeConstants.SIGNUP_ROUTE }
            />
            <ProtectedRoute
              path={ routeConstants.DEUCE_PREMIUM_PAGE }
              component={ DeucePremium }
              condition={ () => ConditionHelperObj.isUserLogged() }
              elseRoute={ routeConstants.SIGNUP_ROUTE }
            />
            <ProtectedRoute
              path={ routeConstants.UPDATE_CARD_ROUTE }
              component={ UpdateCard }
              condition={ () => ConditionHelperObj.isUserLogged() }
              elseRoute={ routeConstants.SIGNUP_ROUTE }
            />
            <AnalyticsRoute
              exact
              path={ routeConstants.FORGOT_PASSWORD_ROUTE }
              component={ ForgotPassword }
            />
            <AnalyticsRoute
              exact
              path={ routeConstants.RESET_PASSWORD_ROUTE }
              component={ ResetPassword }
            />
            <AnalyticsRoute
              path={ routeConstants.ERROR_PAGE }
              component={ ErrorPage }
            />
            <AnalyticsRoute component={ ErrorPage } />
          </Switch>
        </App>
      </ErrorBoundary>
    );
  }
}

AppRoutes.propTypes = {
  defaultHomeRoute: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  defaultHomeRoute: state.config.data.default_home_route,
  showAccount: state.config.data && state.config.data.turn_on_payments
});

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(AppRoutes)
);



// WEBPACK FOOTER //
// ./src/routes.js